import { Injectable } from "@angular/core";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { AccessibilityService } from "./accessibility.service";

@Injectable()
export class SpinnerService {
    constructor(private actualSpinnerService: NgxUiLoaderService, private accessibilityService: AccessibilityService) {
    }

    private tasksShowingSpinner = 0;
    private startTime: number;
    
    show() {
        this.tasksShowingSpinner++;
        console.log(`tasks awaiting spinners: ${this.tasksShowingSpinner}`);
        
        this.actualSpinnerService.start();

        //append <span class="startloading" style="color: #000">Start loading</span> in loading icon html
        this.accessibilityService.startloadingAccessibility();
    }

    hide() {

        if (this.tasksShowingSpinner > 0)
            this.tasksShowingSpinner--;
        
        console.log(`tasks awaiting spinners: ${this.tasksShowingSpinner}`);

        if (this.tasksShowingSpinner === 0) {
            console.log('STOPPING SPINNER')
            this.actualSpinnerService.stop();
            //append <span class='dataloaded' style='color: #000'>Data loaded</span> in loading icon html
            this.accessibilityService.loadedAccessibility();
        }
    }
}